import { createSlice } from '@reduxjs/toolkit';
import { Balloon } from '../../interfaces/Ballooning';

interface StateProps {
	ballooningProject: {
		id: string | null;
		balloons: Balloon[] | [];
	};
}

const initialState: StateProps = {
	ballooningProject: {
		id: null,
		balloons: [],
	},
};

export const ballooning = createSlice({
	name: 'ballooning',
	initialState,
	reducers: {
		setBallooningProject: (state, action) => {
			state.ballooningProject = action.payload;
		},
		updateBalloon: (state, action) => {
			state.ballooningProject.balloons = state.ballooningProject.balloons.map(
				(balloon) => {
					if (balloon.id === action.payload.id) {
						return action.payload;
					} else {
						return balloon;
					}
				}
			);
		},
	},
});

// Action creators are generated for each case reducer function
export const { setBallooningProject, updateBalloon } = ballooning.actions;

export default ballooning.reducer;
